import type { TModule } from '@modules/core/types';

import { PARTNERS_PLATFORM_ROUTE_PATHS } from './config';
import { PARTNERS_ROUTES } from './partners';

const partnersPlatformModule: TModule = {
  id: 'partners-platform',
  fallbackRoute: [PARTNERS_PLATFORM_ROUTE_PATHS.partners],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...PARTNERS_ROUTES],
};

export { PARTNERS_PLATFORM_ROUTE_PATHS as PartnersPlatformRoutePaths };

export default partnersPlatformModule;
